import {
    StyleSheet, View, Text
} from "react-native";

import { FONT } from "../../../value/staticValues";

import { useTranslation } from "react-i18next";
import { ReactComponent as TableEditImg } from '../../../img/ico-table-edit.svg';
import { ContentContainerProps } from "../../../interfaceTypes/ContentsProps";

import ListTable from "../../base/table/listTable";
import { numberOfCommas, parseLocaleDatetime } from "common/util";
import { LicenseData } from "./LicenseData";
import ContentBox from "components/base/tamplate/ContentBox";
import { actionMenus } from "./RdsClientDeviceData";



interface LicenseDetailProps extends ContentContainerProps {
    updateFunction: Function;
    deactivateLicenseFunction: Function;
    refreshYn: boolean;
    loadMainDataYn: boolean;
    selectRow:Function;
    fetchData:any;
    totalCount:number;
    headers:any;

    detailData: LicenseData;

}

export default function LicenseDetail(props:LicenseDetailProps) {
    const { t } = useTranslation();

    return (
        <ContentBox title={t("SERVICE_PRODUCT_DETAIL_TITLE")} subtitle={t("SERVICE_PRODUCT_DETAIL_SUBTITLE")} infoText={props.infoText} infoError={props.infoError} back={true} >
            <View style={style.topContainer}>
                <View style={{
                    flexDirection: "row", alignItems: "center", justifyContent: "flex-end"
                }}>
                    <View style={{ flexDirection: "row", alignItems: "center" }}>
                        <Text style={style.dateTitle}>
                            {t("LAST_UPDATE_DATE_TEXT")}
                        </Text>
                        <Text style={style.dateData}>
                            {props.detailData && props.detailData.update_ts ? props.detailData.update_ts : ""}
                        </Text>
                    </View>
                    <View style={{ flexDirection: "row", alignItems: "center", marginLeft: 30 }}>
                        <Text style={style.dateTitle}>
                            {t("CREATE_DATE_TEXT")}
                        </Text>
                        <Text style={style.dateData}>
                            {props.detailData && props.detailData.create_ts ? props.detailData.create_ts : ""}
                        </Text>
                    </View>
                </View>
                <View>
                    <View style={{...style.boxContainer, height: 400}}>
                        <View style={{flexDirection: "row", alignItems: "center", marginBottom: 50}}>
                            <Text style={style.boxContentTitle}>
                                {t("BASE_INFO_TEXT")}
                            </Text>
                            <div 
                                style={{display: "flex", alignItems: "center", marginLeft: "auto", cursor: "pointer"}}
                                onClick={() => {
                                    props.updateFunction();
                                }}
                            >
                                <TableEditImg/>
                                <Text style={{
                                    marginLeft: 2,
                                    fontFamily: FONT.MEDIUM,
                                    fontSize: 12,
                                    color: "#3c5df2"
                                }}>
                                    {t("INFO_EDIT_TEXT")}
                                </Text>
                            </div>
                        </View>
                        <View style={{flexDirection: "row"}}>
                            <View style={{width: 490}}>
                                <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                    <Text style={style.boxContentHeaderText}>
                                        {t("SERVICE_LICENSE_NUMBER_TEXT")}
                                    </Text>
                                    <Text style={{...style.boxContentDataText,fontFamily: FONT.MEDIUM, fontSize: 14, marginRight: 14}}>
                                        {props.detailData.license_number}
                                    </Text>
                                </View>
                            </View>
                            <View style={{width: 490}}>
                                <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                    <Text style={style.boxContentHeaderText}>
                                        {t("SERVICE_LICENSE_NAME_TEXT")}
                                    </Text>
                                    <Text style={{...style.boxContentDataText,fontFamily: FONT.MEDIUM, fontSize: 14, marginRight: 14}}>
                                        {props.detailData.license_name}
                                    </Text>
                                </View>
                            </View>
                        </View>
                        <View style={{flexDirection: "row"}}>
                            <View style={{width: 490}}>
                                <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                    <Text style={style.boxContentHeaderText}>
                                        {t("SERVICE_PRODUCT_NAME_TEXT")}
                                    </Text>
                                    <Text style={{...style.boxContentDataText,fontFamily: FONT.MEDIUM, fontSize: 14, marginRight: 14}}>
                                        {props.detailData.product?.product_name || ""}
                                    </Text>
                                </View>
                            </View>
                            <View style={{width: 490}}>
                                <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                    <Text style={style.boxContentHeaderText}>
                                        {t("ACCOUNT_TEXT")}
                                    </Text>
                                    <Text style={{...style.boxContentDataText,fontFamily: FONT.MEDIUM, fontSize: 14, marginRight: 14}}>
                                        {props.detailData.email || ""}
                                    </Text>
                                </View>
                            </View>
                        </View>
                        <View style={{flexDirection: "row"}}>
                            <View style={{width: 490}}>
                                <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                    <Text style={style.boxContentHeaderText}>
                                        {t("SERVICE_PURCHASE_SOURCE_TEXT")}
                                    </Text>
                                    <Text style={{...style.boxContentDataText,fontFamily: FONT.MEDIUM, fontSize: 14, marginRight: 14}}>
                                        {props.detailData.purchase_source || "FornaX Cloud Official Site"}
                                    </Text>
                                </View>
                            </View>
                            <View style={{width: 490}}>
                                
                            </View>
                        </View>
                        <View style={{flexDirection: "row"}}>
                            <View style={{width: 490}}>
                                <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                    <Text style={style.boxContentHeaderText}>
                                        {t("SERVICE_LICENSE_DEVICE_COUNT_TEXT")}
                                    </Text>
                                    <Text style={style.boxContentDataText}>
                                        {props.detailData.device_count > 0 ? numberOfCommas(props.detailData.device_count) + " 개" : "0 개"}
                                    </Text>
                                </View>
                            </View>
                            <View style={{width: 490}}>
                                <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                    <Text style={style.boxContentHeaderText}>
                                        {t("SERVICE_LICENSE_USER_COUNT_TEXT")}
                                    </Text>
                                    <Text style={style.boxContentDataText}>
                                        {props.detailData.multi_user_count > 0 ? numberOfCommas(props.detailData.multi_user_count) + " 개" : "0 개"}
                                    </Text>
                                </View>
                            </View>
                        </View>
                        <View style={{flexDirection: "row"}}>
                            <View style={{width: 490}}>
                                <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                    <Text style={style.boxContentHeaderText}>
                                        {t("SERVICE_LICENSE_MONITOR_COUNT_TEXT")}
                                    </Text>
                                    <Text style={style.boxContentDataText}>
                                        {props.detailData.multi_monitor_count > 0 ? numberOfCommas(props.detailData.multi_monitor_count) + " 개" : "0 개"}
                                    </Text>
                                </View>
                            </View>
                            <View style={{width: 490}}>
                                <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                    <Text style={style.boxContentHeaderText}>
                                        {t("SERVICE_LICENSE_UPGRADE_SUPPORT_YEARS_TEXT")}
                                    </Text>
                                    <Text style={style.boxContentDataText}>
                                        {
                                            props.detailData.upgrade_support_years > 0 ? numberOfCommas(props.detailData.upgrade_support_years) + " 년" : props.detailData.use_expire_dates > 0 ? "사용 기간 동일" : "0 년"
                                        }
                                        {
                                            props.detailData.upgrade_support_expire_ts ? "  (" + parseLocaleDatetime(props.detailData.upgrade_support_expire_ts) + ")" : ""
                                        }
                                    </Text>
                                </View>
                            </View>
                        </View>
                        <View style={{flexDirection: "row"}}>
                            <View style={{width: 490}}>
                                <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                    <Text style={style.boxContentHeaderText}>
                                        {t("SERVICE_LICENSE_USE_EXPIRE_DATE_TEXT")}
                                    </Text>
                                    <Text style={style.boxContentDataText}>
                                        {props.detailData.use_expire_dates > 0 ? numberOfCommas(props.detailData.use_expire_dates) + " 일" : "사용 만료 없음"}
                                        {props.detailData.license_expire_ts ? "  (" + parseLocaleDatetime(props.detailData.license_expire_ts) + ")" : ""}
                                    </Text>
                                </View>
                            </View>
                            <View style={{width: 490}}>
                                <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                    <Text style={style.boxContentHeaderText}>
                                        {t("SERVICE_LICENSE_ACESSIBILITY_COUNT_TEXT")}
                                    </Text>
                                    <Text style={style.boxContentDataText}>
                                        {props.detailData.relay_session_count > 0 ? numberOfCommas(props.detailData.relay_session_count) + " 개" : "0 개"}
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={{...style.boxContainer, height: 720}}>
                        <View style={{flexDirection: "row", alignItems: "center"}}>
                            <Text style={{...style.boxContentTitle, fontFamily: FONT.REGULAR, color: "#3a3b3f"}}>
                                {t("SERVICE_ACTIVATED_DEVICE_LIST_TEXT")}
                            </Text>
                        </View>{
                            props.loadMainDataYn == true?
                            <View style={{marginTop: 24}}>
                                <ListTable
                                    id={"activatedRdsClientDeviceManagement"}
                                    actionMenus={actionMenus}
                                    actionMenuClickCb={(code)=>{ if (code === "DEVICE_DEACTIVATE") props.deactivateLicenseFunction();}}
                                    searchBarYn={false}
                                    pageYn={true}
                                    rowCheckYn={true}
                                    rowCheckCb={props.selectRow}
                                    fetchDataCb={props.fetchData}
                                    pageCount={1}
                                    pageSize={50}
                                    tableHeaders={props.headers}
                                    tableData={props.detailData.devices ? props.detailData.devices : []}
                                    totalItemCount={props.detailData.devices.length || 0}
                                    detailYn={true}
                                    refreshYn={props.refreshYn}
                                    canLoadYn={true}
                                    minHeight={430}
                                />
                            </View>:null
                        }
                    </View>
                </View>
            </View>
        </ContentBox>
    );
}



const style = StyleSheet.create({
    topContainer: {
        width: 1115,
        minHeight: 860,
    },
    boxContainer: {
        marginTop: 20,
        paddingTop: 34, paddingLeft: 50, paddingRight: 40, paddingBottom: 45,
        borderRadius: 8,
        boxShadow: "0 10px 12px 0 rgba(63, 63, 68, 0.05), 0 1px 3px 0 rgba(0, 0, 0, 0.05)",
        borderStyle: "solid", borderWidth: 1, borderColor: "#e5e9ec",
        backgroundColor: "#fff"
    },
    dateTitle: {
        marginRight: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 10,
        color: "#8793a3"
    },
    dateData: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#9ea0a5"
    },
    boxContentTitle: {
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        color: "#333"
    },
    boxContentHeaderText: {
        width: 130,
        marginRight: 52,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        lineHeight: 12,
        color: "#333"
    },
    boxContentDataText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333"
    },
    settingImg: {
        marginLeft: "auto",
        cursor: "pointer"
    },
    resourceBox: {
        flexDirection: "row",
        width: 760, minHeight: 70,
        borderRadius: 10,
        backgroundColor: "#f5f7fa",
        padding: 20,
    },
    imgBox: {
        alignItems: "center", justifyContent: "center",
        width: 36, height: 36,
        marginRight: 16,
        borderRadius: 10,
        backgroundColor: "rgba(182, 191, 206, 0.3)",
    },
    resourceFixedText: {
        width: 75,
        marginRight: 90,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        lineHeight: 12,
        color: "#333"
    },
    resourceDataText: {
        fontFamily: FONT.BOLD,
        fontSize: 14,
        lineHeight: 14,
        color: "#333"
    },
    resourceSubText: {
        marginLeft: 6,
        fontFamily: FONT.REGULAR,
        fontSize: 11,
        lineHeight: 10,
        color: "#9ea0a5"
    },
    boxContentBlueDataText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#0853fb"
    }
});